// Тонкая обёртка над общим адаптером resources/js/captcha-adapter.js
// (единый исходник для лендинга и merchant SPA — правки провайдеров там).
import { initCaptcha as initCaptchaForElement } from '../../js/captcha-adapter';

// Инициализация капчи для формы лендинга: виджет рендерится в контейнер
// [data-captcha] внутри формы (см. partials/captcha-slot.blade.php).
export function initCaptcha(form, formName) {
  return initCaptchaForElement(form ? form.querySelector('[data-captcha]') : null, formName);
}
